import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { HttpRequestDataProvider } from './types';

@NgModule({ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class RtHttpModule {
  public static forRoot(
    httpRequestDataProvider: HttpRequestDataProvider,
  ): ModuleWithProviders<RtHttpModule> {
    return { ngModule: RtHttpModule, providers: [httpRequestDataProvider] };
  }
}
